import { Alert, AlertIcon, Link, Text } from '@chakra-ui/react';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { FundingRequestCanBeCreatedErrorCodeEnumGQLType } from '../../../../types/dashboard-core-gqlTypes.generated.d';

const canFundingRequestBeCreatedErrorCodeMap: {
  [errorCode in FundingRequestCanBeCreatedErrorCodeEnumGQLType]: React.ReactElement;
} = {
  bankAccountsAreNotConfiguredProperly: (
    <Text>
      Configure credit facility bank accounts in{' '}
      <Link
        as={RouterLink}
        to="/settings/bank-accounts"
        style={{ textDecoration: 'underline' }}
      >
        Settings
      </Link>
      .
    </Text>
  ),
  classAllocationMethodNotConfigured: (
    <Text>
      Contact support to configure class allocation method before continuing.
    </Text>
  ),
  collectionsPaydownIsAllowedNotConfigured: (
    <Text>
      Contact support to configure collections paydown before continuing.
    </Text>
  ),
  collectionsRecycleIsAllowedNotConfigured: (
    <Text>
      Contact support to configure collections recycle before continuing.
    </Text>
  ),
  currentFundingRequestAlreadyInProgress: (
    <Text>A funding request is currently in progress.</Text>
  ),
  expireDaysOffsetNotConfigured: (
    <Text>
      Contact support to configure funding request expiration days offset before
      continuing.
    </Text>
  ),
  fundingRequestComponentSubmissionNoticePeriodsNotConfigured: (
    <Text>
      Contact support to configure submission notice periods before continuing.
    </Text>
  ),
  isStopDrawEnforcedNotConfigured: (
    <Text>
      Contact support to configure stop draw for insufficient collections cash
      parameter before continuing.
    </Text>
  ),
  latestBorrowingBaseReportIsTooOld: (
    <Text>
      The latest borrowing base report is too old to be used. Create a new
      borrowing base report.
    </Text>
  ),
  maximumBorrowingBaseReportDaysOldNotConfigured: (
    <Text>
      Contact support to configure borrowing base report expiration days limit
      before continuing.
    </Text>
  ),
  noCurrentFundingRequestConstraint: (
    <Text>Create a new borrowing base report to continue.</Text>
  ),
  servicerReportTemplateNotConfigured: (
    <Text>Contact support to configure servicer report before continuing.</Text>
  ),
};

type Props = {
  errorCode: FundingRequestCanBeCreatedErrorCodeEnumGQLType;
};
const CanFundingRequestBeCreatedAlertMessage = ({ errorCode }: Props) => {
  return (
    <Alert status="warning" background="transparent">
      <AlertIcon />
      {canFundingRequestBeCreatedErrorCodeMap[errorCode] || (
        <Text>Contact support.</Text>
      )}
    </Alert>
  );
};

export default CanFundingRequestBeCreatedAlertMessage;
